/**
 * Data Service
 * 
 * This service handles loading data from local JSON files.
 * It replaces the previous api.js and marvelApi.js services since
 * the application now uses local JSON data exclusively.
 */

import heroesData from '../data/heroes.json';

/**
 * Fetch heroes from local JSON data
 * @returns {Array} Array of hero objects
 */
export const fetchHeroes = async () => {
  return heroesData;
};

/**
 * Fetch maps from local JSON data
 * @returns {Array} Array of map objects
 */
export const fetchMaps = async () => {
  const mapsData = require('../data/maps.json');
  return mapsData;
};

/**
 * Fetch ranks from predefined options
 * @returns {Array} Array of rank objects
 */
export const fetchRanks = async () => {
  // Return predefined rank options
  return [
    { id: 'diamond_plus', name: 'Diamond+' },
    { id: 'below_diamond', name: 'Below Diamond' }
  ];
};

/**
 * Fetch hero statistics from local JSON data
 * @returns {Object} Hero statistics data
 */
export const fetchHeroStats = async () => {
  try {
    // Try to load the hero stats data
    const heroStatsData = require('../data/heroStats.json');
    return heroStatsData;
  } catch (error) {
    // If the file doesn't exist or there's an error, return an empty object
    console.error('Error loading hero stats data:', error.message);
    return { heroes: [], lastUpdated: null };
  }
};